import { render, staticRenderFns } from "./PublicationDate.vue?vue&type=template&id=cf0b9e62&scoped=true"
import script from "./PublicationDate.vue?vue&type=script&lang=js"
export * from "./PublicationDate.vue?vue&type=script&lang=js"
import style0 from "./PublicationDate.vue?vue&type=style&index=0&id=cf0b9e62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0b9e62",
  null
  
)

export default component.exports